import { useState } from 'react'

import { meetingApi } from '../api'

const useStopRecording = () => {
  const [isStopping, setIsStopping] = useState(false)

  const stopRecording = async (meetingId: string) => {
    setIsStopping(true)

    try {
      const meeting = await meetingApi.stopRecording(meetingId)
      return meeting
    } catch (error) {
      console.error('Failed to stop recording', error)
    } finally {
      setIsStopping(false)
    }
  }

  return { isStopping, stopRecording }
}
export default useStopRecording
